interface ThemeColors {
  accentColor?: string;
}

export const injectThemeColors = (theme: ThemeColors) => {
  const root = document.documentElement;

  if (theme.accentColor) {
    root.style.setProperty('--workspace-accent', theme.accentColor);
    root.style.setProperty('--workspace-accent-hover', adjustColorBrightness(theme.accentColor, -10));
    root.style.setProperty('--workspace-accent-light', adjustColorBrightness(theme.accentColor, 40));
  }
};

export const removeThemeColors = () => {
  const root = document.documentElement;
  root.style.removeProperty('--workspace-accent');
  root.style.removeProperty('--workspace-accent-hover');
  root.style.removeProperty('--workspace-accent-light');
};

function adjustColorBrightness(hex: string, percent: number): string {
  const num = parseInt(hex.replace('#', ''), 16);
  const amt = Math.round(2.55 * percent);
  const R = (num >> 16) + amt;
  const G = (num >> 8 & 0x00FF) + amt;
  const B = (num & 0x0000FF) + amt;

  return '#' + (
    0x1000000 +
    (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
    (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
    (B < 255 ? (B < 1 ? 0 : B) : 255)
  ).toString(16).slice(1).toUpperCase();
}
